import { Select } from '../../../shared/components';
import { ParamUser, ParamActivity } from '../../../shared/services/settings/types';
import { ReportFilters } from '../../../shared/services/reports/types';

interface ReportsFiltersProps {
  value: ReportFilters;
  onChange: (value: ReportFilters) => void;
  users: ParamUser[];
  activities: ParamActivity[];
}

export function ReportsFilters({ value, onChange, users, activities }: ReportsFiltersProps) {
  const update = (patch: Partial<ReportFilters>) => onChange({ ...value, ...patch });

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <label className="block">
        <input
          type="date"
          value={value.dateFrom ?? ''}
          onChange={(e) => update({ dateFrom: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <label className="block">
        <input
          type="date"
          value={value.dateTo ?? ''}
          onChange={(e) => update({ dateTo: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <Select
        placeholder="Todos los usuarios"
        options={users.map((u) => ({ value: u.id, label: u.fullName }))}
        value={value.userId ?? ''}
        onChange={(e) => update({ userId: e.target.value })}
      />
      <Select
        placeholder="Todas las actividades"
        options={activities.map((a) => ({ value: a.id, label: a.name }))}
        value={value.activityId ?? ''}
        onChange={(e) => update({ activityId: e.target.value })}
      />
    </div>
  );
}
